"use strict";

var _interopRequireDefault = require("/www/wwwroot/python/front/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/python/front/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _request2 = _interopRequireDefault(require("@/utils/request4"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _formatMixin = require("@/utils/formatMixin");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _encrypt = require("@/utils/encrypt");
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      // 修改余额form
      accoutform: {
        sumcharge: '',
        recharge: 0 // 充值余额
      },
      // 余额提现form
      accoutform1: {
        sumcharge: '',
        withdrawal: 0 //提现余额
      },
      dialogVisibleAccount: false,
      //控制修改余额form
      dialogVisibleAccount1: false,
      //控制余额提现form
      // 顶部搜索框form数据
      formInline: {
        keyword: '',
        //搜索关键词
        start_time: '',
        remark: '',
        end_time: '',
        gmoney: '',
        lmoney: ''
      },
      lastExecutedTime: 0,
      // 上次执行的时间
      dialogFormVisible: false,
      datenum: [],
      money: 0,
      // 商家余额
      moneyList: {
        count: 0
      },
      // 划扣流水
      listQuery: {
        page: 1,
        page_size: 10
      },
      listLoading: false,
      msgBtnTxt: '获取验证码',
      msg_code: '',
      pk: 0,
      isRequesting: false,
      product_name: ''
    };

    // 控制按钮是否禁用的标志位
  },
  created: function created() {
    this.getMoneyList();
    // console.log(this.$user.data)

    // console.log(this.$user)
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['name', 'perms'])), {}, {
    // isAdmin
    // 如果perms包含 admin 字段 即为管理员，则返回true  否则为false
    isAdmin: function isAdmin() {
      return this.perms.includes('admin');
    },
    is_withdrawal: function is_withdrawal() {
      return this.perms.includes('withdrawal_ok');
    },
    start_time: function start_time() {
      return this.datenum[0] ? this.formatDate(this.datenum[0]) : '';
    },
    end_time: function end_time() {
      return this.datenum[1] ? this.formatDate(this.datenum[1]) : '';
    }
  }),
  methods: {
    // 格式化日期,需要加上时分秒的数据
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
      var day = String(date.getDate()).padStart(2, '0');
      var hour = String(date.getHours()).padStart(2, '0');
      var minute = String(date.getMinutes()).padStart(2, '0');
      var second = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
    },
    resetFilter: function resetFilter() {
      this.formInline.keyword = '';
      this.formInline.start_time = '';
      this.formInline.remark = '';
      this.formInline.end_time = '';
      this.formInline.gmoney = '';
      this.formInline.lmoney = '';
      this.datenum = [];
      this.handleFilter();
    },
    // 搜索
    handleFilter: function handleFilter() {
      this.listLoading = true;
      this.listQuery.page = 1;
      this.listQuery.page_size = 10;
      this.getMoneyList();
    },
    // 获取划扣流水——done
    getMoneyList: function getMoneyList() {
      var _this = this;
      this.listLoading = true;
      (0, _request.default)({
        url: "/system/order/getUserRecord/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          type: 1,
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          value: this.formInline.keyword,
          remark: this.formInline.remark,
          start_time: this.start_time,
          end_time: this.end_time,
          gmoney: this.formInline.gmoney,
          lmoney: this.formInline.lmoney,
          is_pay: 1
        }
      }).then(function (response) {
        if (response.data) {
          _this.moneyList = response.data.data;
          _this.accoutform.sumcharge = response.data.data.real_money;
          _this.accoutform1.sumcharge = response.data.data.real_money;
          _this.product_name = response.data.data.product_name;
        }
        _this.listLoading = false;
      });
    },
    approve: function approve(value) {
      this.dialogFormVisible = true;
      this.pk = value.pk;
    },
    getCode: function getCode() {
      var _this2 = this;
      //  1.验证手机号
      // 成功则发验证码
      // 参数加密
      var timestamp = Date.now().toString();
      //   let safe = encrypt('18232525083'+ `&` + timestamp)
      var safe = (0, _encrypt.encrypt)('13017111117' + "&" + timestamp);
      // 发请求
      (0, _request.default)({
        url: 'anon/send_msg',
        method: 'post',
        data: {
          mobile: '13017111117',
          timestamp: timestamp,
          safe: safe
        }
      }).then(function (res) {
        _this2.$message.success('验证码发送成功');
        _this2.cycleMsg(60);
      });
    },
    // 倒计时
    cycleMsg: function cycleMsg(currentSecond) {
      var _this3 = this;
      if (currentSecond > 0) {
        this.msgBtnTxt = "".concat(currentSecond, "\u79D2");
        setTimeout(function () {
          return _this3.cycleMsg(currentSecond - 1);
        }, 1000);
      } else {
        this.msgBtnTxt = '获取验证码';
      }
    },
    clossPop: function clossPop() {
      var _this4 = this;
      var timestamp = Date.now().toString();
      var safe = (0, _encrypt.encrypt)('13017111117' + "&" + this.msg_code + "&" + timestamp);
      // 发请求
      (0, _request.default)({
        url: 'anon/check_msg',
        method: 'post',
        data: {
          mobile: '13017111117',
          msg_code: this.msg_code,
          timestamp: timestamp,
          safe: safe
        }
      }).then(function (res) {
        if (res.code == 200) {
          _this4.dialogFormVisible = false;
          _this4.onSubmitAccount();
        }
      });
    },
    // 修改余额保存，加限制——done
    onSubmitAccount: function onSubmitAccount() {
      var _this5 = this;
      var currentTime = Date.now();
      if (currentTime - this.lastExecutedTime > 2000) {
        if (this.accoutform.recharge < 1) {
          this.$message.error('最少1元');
          return;
        }
        this.isRequesting = true; // 禁用按钮
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/money/",
          method: 'put',
          data: {
            shop_id: this.$user.data.shop,
            // customer: this.document.customer,
            money: this.accoutform.recharge
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this5.dialogVisibleAccount = false;
            _this5.accoutform.recharge = 0;
            // this.getList()//重新获取数据
            _this5.getMoneyList(); // 重新获取充值余额流水
            _this5.isRequesting = false; // 启用按钮
            _this5.lastExecutedTime = currentTime;
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.$message.error('请勿频繁操作');
        this.lastExecutedTime = currentTime;
      }
    },
    // 余额提现保存，加限制——done
    onSubmitAccount1: function onSubmitAccount1() {
      var _this6 = this;
      var currentTime = Date.now();
      if (currentTime - this.lastExecutedTime > 2000) {
        if (this.accoutform1.withdrawal < 1) {
          this.$message.error('最少1元');
          return;
        }
        this.isRequesting = true; // 禁用按钮
        // 发请求提交数据给后端
        (0, _request.default)({
          url: "/system/user/moneyDec/",
          method: 'put',
          data: {
            shop_id: this.$user.data.shop,
            // customer: this.document.customer,
            money: this.accoutform1.withdrawal
          }
        }).then(function (response) {
          if (response.code == 200) {
            _this6.dialogVisibleAccount1 = false;
            _this6.accoutform.withdrawal = 0;
            // this.getList()//重新获取数据
            _this6.getMoneyList(); // 重新获取充值余额流水
            _this6.isRequesting = false; // 启用按钮
            _this6.lastExecutedTime = currentTime;
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.$message.error('请勿频繁操作');
        this.lastExecutedTime = currentTime;
      }
    }
  }
};